import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const timeline = [
    {
      week: 'Week 1',
      title: 'Discovery & Connection',
      icon: '1',
      items: [
        'Kickoff call to understand your current systems',
        'Connect your booking platform (Vagaro, Boulevard, etc.)',
        'Map your locations and service catalog',
        'Initial data sync begins automatically'
      ]
    },
    {
      week: 'Week 2',
      title: 'Data Integration',
      icon: '2',
      items: [
        'Payment and transaction data flows in',
        'Phone call tracking connected',
        'Historical patterns start emerging',
        'First insights preview ready for review'
      ]
    },
    {
      week: 'Week 3',
      title: 'Dashboard Configuration',
      icon: '3',
      items: [
        'Custom dashboards built for your metrics',
        'Alerts configured for what matters to you',
        'Multi-location views set up',
        'Team access and permissions configured'
      ]
    },
    {
      week: 'Week 4',
      title: 'Training & Launch',
      icon: '4',
      items: [
        'Walkthrough of your personalized insights',
        'Train your team on daily use',
        'Go live with confidence',
        'Ongoing support starts'
      ]
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="how-it-works" className="how-it-works-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Your 30-Day Build</h2>
          <p className="section-subtitle">
            From first call to full visibility. Here's exactly what to expect.
          </p>
        </div>

        <div className="timeline">
          {timeline.map((phase, index) => (
            <div key={index} className="timeline-phase">
              <div className="phase-marker">
                <div className="marker-circle">{phase.icon}</div>
                {index < timeline.length - 1 && <div className="marker-line"></div>}
              </div>
              <div className="phase-content">
                <span className="phase-week">{phase.week}</span>
                <h3 className="phase-title">{phase.title}</h3>
                <ul className="phase-items">
                  {phase.items.map((item, itemIndex) => (
                    <li key={itemIndex}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="timeline-footer">
          <div className="footer-content">
            <h3>No technical setup on your end.</h3>
            <p>We handle the integrations. You focus on running your business.</p>
            <button className="btn btn-primary" onClick={scrollToContact}>
              Start Your 30-Day Build
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
